/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { globalVar } from "utils/globalVar";
import { combineURLPaths } from "utils/urlHelper";
import { Network } from "../network";
import { guardNetworkCall } from "../networkCallTypeguard";
import { CountryList, BasicDecodeError, LanguageList } from "./models/basic";

const { JUSTICE_API_URL: apiUrl } = globalVar;

export function fetchCountries(network: Network, { namespace, lang }: { namespace: string; lang?: string }) {
  return guardNetworkCall(
    () =>
      network.get(combineURLPaths(apiUrl, `basic/v1/public/namespaces/${namespace}/misc/countries`), {
        params: {
          lang,
        },
      }),
    CountryList,
    BasicDecodeError,
    (error) => error
  );
}

export function fetchLanguages(network: Network, { namespace }: { namespace: string }) {
  return guardNetworkCall(
    () => network.get(combineURLPaths(apiUrl, `basic/v1/public/namespaces/${namespace}/misc/languages`)),
    LanguageList,
    BasicDecodeError,
    (error) => error
  );
}
